import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const boolOrValue = (value) => {
  if (value === true) { return <FontAwesomeIcon icon="check" /> }
  if (value === false) { return <FontAwesomeIcon icon="times" /> }
  return value
}

